import { Link, Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { AuthData } from '../../auth/AuthWrapper'
import { nav } from './navigation'
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { IconLogout, IconUserPlus, IconLockQuestion, IconLogin, IconUser, IconHourglass } from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import userService from '../../services/userService';

export const RenderRoutes = () => {

    const { user } = AuthData()
    return (
        <div>
            <Routes>
                {nav.map((r, i) => {
                    if (r.isPrivate && user.isAuthenticated) {
                        return <Route key={i} path={r.path} element={r.element} />
                    } else if (!r.isPrivate) {
                        return <Route key={i} path={r.path} element={r.element} />
                    } else {
                        return <Route key={i} path={r.path} element={<Navigate to="/login" replace />} />
                    }
                })}
            </Routes>
        </div>
    )
}

export const RenderMenu = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const [appVersion, setAppVersion] = useState('');
    const [fullName, setFullName] = useState('');

    useEffect(() => {
        fetch('/version.json?t=' + Date.now())
            .then(r => r.json())
            .then(data => setAppVersion(data.version))
            .catch(() => {});
    }, []);

    const { user, logout, isRefreshing } = AuthData()

    useEffect(() => {
        const key = sessionStorage.getItem("activationKey");
        if (user.isAuthenticated && key) {
            userService.getUserFromKey(key)
                .then(data => { if (data?.[0]?.AdiSoyadi) setFullName(data[0].AdiSoyadi); })
                .catch(() => {});
        }
    }, [user.isAuthenticated]);

    const changeLang = async lang => {
        await i18n.changeLanguage(lang);
        localStorage.setItem('siteLang', lang);
    }
    
    const MenuItem = ({ r }) => {
        const isActive = location.pathname === r.path;
        return (
            <div className={`menuItem ${isActive ? 'active' : ''}`}>
                <Link to={r.path}>
                    {r.icon}
                    <span>{t(r.name)}</span>
                </Link>
            </div>
        )
    }

    return (
        <div className='sidebar'>
            <div className="sidebar-logo">
                <img onClick={() => { window.location.href = '/' }} src="Kama3DLogo.svg" alt="Kama3D" style={{ width: '100%', maxWidth: '160px', cursor: 'pointer' }} />
                {appVersion && (
                    <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.25)', marginTop: '6px', letterSpacing: '0.5px' }}>
                        v{appVersion}
                    </div>
                )}
            </div>

            <div className="menu-items">
                {nav.map((r, i) => {
                    if (!r.isPrivate && r.isMenu) {
                        return <MenuItem key={i} r={r} />
                    } else if (user.isAuthenticated && r.isMenu) {
                        return <MenuItem key={i} r={r} />
                    } else return false
                })}

                {
                    user.isAuthenticated ?
                        <div className='menuItem logout'>
                            <Link to={'/login'} onClick={(e) => {
                                logout();
                            }}>
                                <IconLogout size={20} />
                                <span>{t('butonCikis')}</span>
                            </Link>
                        </div>
                        :
                        <>
                            <div className='menuItem'><Link to={'addmember'}><IconUserPlus size={20} /><span>{t('butonYeniKullanici')}</span></Link></div>
                            <div className='menuItem'><Link to={'forgotpassword'}><IconLockQuestion size={20} /><span>{t('butonSifremiUnuttum')}</span></Link></div>
                            <div className='menuItem'><Link to={'login'}><IconLogin size={20} /><span>{t('butonGiris')}</span></Link></div>
                        </>
                }
            </div>

            <div className="sidebar-footer">
                {user.isAuthenticated && fullName && (
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '10px',
                        marginBottom: '14px', paddingBottom: '14px',
                        borderBottom: '1px solid #2e3f54',
                    }}>
                        <div style={{
                            width: 34, height: 34, borderRadius: '50%', flexShrink: 0,
                            background: 'rgba(88,164,226,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <IconUser size={16} color="#58a4e2" />
                        </div>
                        <div style={{ overflow: 'hidden' }}>
                            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.35)', letterSpacing: '0.5px', marginBottom: '2px' }}>
                                {i18n.language.startsWith('tr') ? 'Hoşgeldiniz' : 'Welcome'}
                            </div>
                            <div style={{
                                fontSize: '12px', fontWeight: 600, color: 'rgba(255,255,255,0.8)',
                                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                display: 'flex', alignItems: 'center', gap: '6px'
                            }}>
                                {fullName}
                                {isRefreshing && <IconHourglass size={14} className="spin" color="#58a4e2" />}
                            </div>
                        </div>
                    </div>
                )}
                <div className="language-selector">
                    <img onClick={() => changeLang('tr')} src="flag-tr.png" alt="TR" title="Türkçe" />
                    <img onClick={() => changeLang('en')} src="flag-en.png" alt="EN" title="English" />
                </div>
            </div>
        </div>
    )
}